// انواع خودرو
import React from 'react';
import CrudView from './CrudView';
import { Field, TextInput } from './basicShared';

const COLS = [{ key: 'title', label: 'عنوان' }];

function Fields({ f, set }) {
  return (
    <Field label="عنوان">
      <TextInput value={f.title} onChange={v => set('title', v)} autoFocus />
    </Field>
  );
}

export default function CarKinds({ user, onBack }) {
  return (
    <CrudView user={user} onBack={onBack} form="FRMCARKINDS" title="انواع خودرو" unit="نوع"
      path="/car-kinds" cols={COLS} empty={{ title: '' }} renderFields={Fields} />
  );
}
